const SaveGantt = async (isSupervisor, task, taskOlds, id, gantt, thiss) => {
  let isSubmit = false;
  let body = {};
  let ID = id;
  let matchRespAndCurrentUser =
    thiss.currentUser.EmployeeId == taskOlds[0].owner_id;

  if (task.parent != 0) {
    thiss.OpenObjeID = task.parent;
    let TaskID = taskOlds[0].$new ? null : ID;
    // Get parent objective
    let taskParentIndex = gantt.getTaskBy("id", task.parent);
    // Date of Objectives
    const parentDateInit = new Date(taskParentIndex[0].start_date);
    const parentDateEnd = new Date(taskParentIndex[0].end_date);
    // Date of task
    const taskDateInit = new Date(task.start_date);
    const taskDateEnd = new Date(task.end_date);

    let controlsDateTrue = controlsOfDate(
      parentDateInit,
      parentDateEnd,
      taskDateInit,
      taskDateEnd,
      gantt
    );

    if (task.$new) {
      if (controlsDateTrue) {
        let objId = parseInt(task.parent.slice(4));

        body = {
          ID: TaskID,
          CombinedId: TaskID,
          Name: task.text,
          Description: task.text,
          Typetask: "",
          ResponsableId: task.owner_id,
          deparment: "",
          Status: "",
          Details: task.details,
          Percentage: task.progress,
          ObjetiveID: objId,
          CreatedBy: thiss.currentUser.EmployeeId,
          type: "day",
          qty: 0,
          CompanySelected: thiss.currentCompany,
          PerpectiveId: taskParentIndex[0].type,
          ProposalDate: task.end_date,
          InitialDate: task.start_date,
          LimitDate: task.end_date,
          TypeStrategic: taskParentIndex[0].type_strategic
        };
        thiss.loading = true;

        // SubTasks
        if (task.parent.includes("Task") && !isSubmit) {
          body = {
            ID: TaskID,
            CombinedId: TaskID,
            TaskGanttID: task.parent.slice(5),
            Name: task.text,
            Description: task.text,
            Typetask: "",
            ResponsableId: task.owner_id,
            deparment: "",
            Status: "",
            Details: task.details,
            Percentage: task.progress,
            TaskCombinedId: task.parent,
            CreatedBy: thiss.currentUser.EmployeeId,
            type: "day",
            qty: 0,
            CompanySelected: thiss.currentCompany,
            PerpectiveId: taskParentIndex[0].type,
            ProposalDate: task.end_date,
            InitialDate: task.start_date,
            LimitDate: task.end_date,
            TypeStrategic: await taskParentIndex[0].type_strategic
          };
          try {
            await thiss.$http.post(
              "/api/cmi/SubTaskGantt/AddSubTaskGantt",
              body
            );
            let message = body.ID
              ? "La Subtarea fue editada"
              : "La Subtarea fue creada";
            thiss.$message.success(message);
            thiss.GetGanttObjectives();
            isSubmit = true;
          } catch (err) {
            console.error(err);
            thiss.GetGanttObjectives();
            isSubmit = true;
          }
          return true;
        }

        if (!isSubmit) {
          try {
            await thiss.$http.post("/api/cmi/task/AddTaskGantt", body);
            let message = body.ID
              ? "La tarea fue editada"
              : "La tarea fue creada";
            thiss.$message.success(message);
            thiss.GetGanttObjectives();
            isSubmit = true;
          } catch (err) {
            console.error(err);
            thiss.GetGanttObjectives();
            isSubmit = true;
          }
        }
        return true;
      }
      return;
    } else {
      if (
        !isSupervisor &&
        matchRespAndCurrentUser &&
        thiss.currentUser.EmployeeId != task.created_by &&
        (taskOlds[0].text != task.text ||
          taskOlds[0].details != task.details ||
          taskOlds[0].owner_id.toString() != Number(task.owner_id) ||
          new Date(taskOlds[0].start_date).getTime() !=
            new Date(task.start_date).getTime() ||
          new Date(taskOlds[0].end_date).getTime() !=
            new Date(task.end_date).getTime() ||
          taskOlds[0].duration != task.duration ||
          taskOlds[0].parent != task.parent) &&
        !isSubmit
      ) {
        gantt.alert({
          text: "Usted solo puede modificar el progreso.",
          title: "Error!",
          ok: "OK",
          type: "error",
          callback: function (result) {
            if (result) thiss.GetGanttObjectives();
          }
        });
        thiss.isSupervisor = false;
        return false;
      } else if (
        ((!isSupervisor &&
          matchRespAndCurrentUser &&
          thiss.currentUser.EmployeeId != task.created_by &&
          taskOlds[0].progress != task.progress) ||
          (isSupervisor &&
            matchRespAndCurrentUser &&
            thiss.currentUser.EmployeeId != task.created_by &&
            taskOlds[0].progress != task.progress)) &&
        !isSubmit
      ) {
        if (task.progress == 100 && !task.evidence) {
          await KnowIfThereIsTimeToAsign(task, thiss).then((data) => {
            const isThereTimeToAsign = data;
            // if (this.fileList !== "" && this.fileList !== undefined) {
            //   this.__helperRequestChangeStatus(2, option);
            //   break;
            // }
            if (isThereTimeToAsign === false) {
              thiss.dialogVisible = true;
              thiss.TaskID = ID;
              thiss.TaskProgressOlds = taskOlds[0].progress;
            } else {
              thiss.$alert(
                "Aun tiene tareas o solicitudes pendientes de asignarles tiempo, " +
                  "para ello dirijase al reporte de tareas en mis solicitudes o" +
                  "comuniquese con su supervisor  para asignarles tiempo.",
                "Tiene Solicitudes o tareas sin tiempo asignado",
                {
                  type: "error"
                }
              );
            }
          });
          return;
        }

        if (controlsDateTrue) {
          let objId = parseInt(task.parent.slice(4));

          // SubTasks
          if (task.parent.includes("Task")) {
            body = {
              ID: TaskID,
              CombinedId: TaskID,
              TaskGanttID: task.parent.slice(5),
              Name: task.text,
              Description: task.text,
              Typetask: "",
              ResponsableId: task.owner_id,
              deparment: "",
              Status: "",
              Details: task.details,
              Percentage: task.progress,
              TaskCombinedId: task.parent,
              CreatedBy: thiss.currentUser.EmployeeId,
              type: "day",
              qty: 0,
              CompanySelected: thiss.currentCompany,
              PerpectiveId: taskParentIndex[0].type,
              ProposalDate: task.end_date,
              InitialDate: task.start_date,
              LimitDate: task.end_date,
              TypeStrategic: await taskParentIndex[0].type_strategic
            };
            try {
              await thiss.$http.post(
                "/api/cmi/SubTaskGantt/AddSubTaskGantt",
                body
              );
              let message = body.ID
                ? "La Subtarea fue editada"
                : "La Subtarea fue creada";
              thiss.$message.success(message);
              thiss.GetGanttObjectives();
              isSubmit = true;
            } catch (err) {
              console.error(err);
              thiss.GetGanttObjectives();
              isSubmit = true;
            }
            return true;
          }

          body = {
            ID: TaskID,
            CombinedId: TaskID,
            Name: task.text,
            Description: task.text,
            Typetask: "",
            ResponsableId: task.owner_id,
            deparment: "",
            Status: "",
            Details: task.details,
            Percentage: task.progress,
            ObjetiveID: objId,
            CreatedBy: thiss.currentUser.EmployeeId,
            type: "day",
            qty: 0,
            CompanySelected: thiss.currentCompany,
            PerpectiveId: taskParentIndex[0].type,
            ProposalDate: task.end_date,
            InitialDate: task.start_date,
            LimitDate: task.end_date,
            TypeStrategic: taskParentIndex[0].type_strategic
          };
          thiss.loading = true;

          // SubTasks
          if (task.parent.includes("Task") && !isSubmit) {
            body = {
              ID: TaskID,
              CombinedId: TaskID,
              TaskGanttID: task.parent.slice(5),
              Name: task.text,
              Description: task.text,
              Typetask: "",
              ResponsableId: task.owner_id,
              deparment: "",
              Status: "",
              Details: task.details,
              Percentage: task.progress,
              TaskCombinedId: task.parent,
              CreatedBy: thiss.currentUser.EmployeeId,
              type: "day",
              qty: 0,
              CompanySelected: thiss.currentCompany,
              PerpectiveId: taskParentIndex[0].type,
              ProposalDate: task.end_date,
              InitialDate: task.start_date,
              LimitDate: task.end_date,
              TypeStrategic: await taskParentIndex[0].type_strategic
            };
            try {
              await thiss.$http.post(
                "/api/cmi/SubTaskGantt/AddSubTaskGantt",
                body
              );
              let message = body.ID
                ? "La Subtarea fue editada"
                : "La Subtarea fue creada";
              thiss.$message.success(message);
              thiss.GetGanttObjectives();
              isSubmit = true;
            } catch (err) {
              console.error(err);
              thiss.GetGanttObjectives();
              isSubmit = true;
            }
            return true;
          }

          if (!isSubmit) {
            try {
              await thiss.$http.post("/api/cmi/task/AddTaskGantt", body);
              let message = body.ID
                ? "La tarea fue editada"
                : "La tarea fue creada";
              thiss.$message.success(message);
              thiss.GetGanttObjectives();
              isSubmit = true;
            } catch (err) {
              console.error(err);
              thiss.GetGanttObjectives();
              isSubmit = true;
            }
          }
          return true;
        }
        return;
      } else if (
        (isSupervisor ||
          matchRespAndCurrentUser ||
          thiss.currentUser.EmployeeId == task.created_by) &&
        !isSubmit
      ) {
        if (task.progress == 100 && !task.evidence) {
          await KnowIfThereIsTimeToAsign(task, thiss).then((data) => {
            const isThereTimeToAsign = data;
            // if (this.fileList !== "" && this.fileList !== undefined) {
            //   this.__helperRequestChangeStatus(2, option);
            //   break;
            // }
            if (isThereTimeToAsign === false) {
              thiss.dialogVisible = true;
              thiss.TaskID = ID;
              thiss.TaskProgressOlds = taskOlds[0].progress;
            } else {
              thiss.$alert(
                "Aun tiene tareas o solicitudes pendientes de asignarles tiempo, " +
                  "para ello dirijase al reporte de tareas en mis solicitudes o" +
                  "comuniquese con su supervisor  para asignarles tiempo.",
                "Tiene Solicitudes o tareas sin tiempo asignado",
                {
                  type: "error"
                }
              );
            }
          });
          return;
        }

        if (controlsDateTrue) {
          let objId = parseInt(task.parent.slice(4));

          body = {
            ID: TaskID,
            CombinedId: TaskID,
            Name: task.text,
            Description: task.text,
            Typetask: "",
            ResponsableId: task.owner_id,
            deparment: "",
            Status: "",
            Details: task.details,
            Percentage: task.progress,
            ObjetiveID: objId,
            CreatedBy: thiss.currentUser.EmployeeId,
            type: "day",
            qty: 0,
            CompanySelected: thiss.currentCompany,
            PerpectiveId: taskParentIndex[0].type,
            ProposalDate: task.end_date,
            InitialDate: task.start_date,
            LimitDate: task.end_date,
            TypeStrategic: taskParentIndex[0].type_strategic
          };
          thiss.loading = true;

          // SubTasks
          if (task.parent.includes("Task")) {
            body = {
              ID: TaskID,
              CombinedId: TaskID,
              TaskGanttID: task.parent.slice(5),
              Name: task.text,
              Description: task.text,
              Typetask: "",
              ResponsableId: task.owner_id,
              deparment: "",
              Status: "",
              Details: task.details,
              Percentage: task.progress,
              TaskCombinedId: task.parent,
              CreatedBy: thiss.currentUser.EmployeeId,
              type: "day",
              qty: 0,
              CompanySelected: thiss.currentCompany,
              PerpectiveId: taskParentIndex[0].type,
              ProposalDate: task.end_date,
              InitialDate: task.start_date,
              LimitDate: task.end_date,
              TypeStrategic: await taskParentIndex[0].type_strategic
            };
            try {
              await thiss.$http.post(
                "/api/cmi/SubTaskGantt/AddSubTaskGantt",
                body
              );
              let message = body.ID
                ? "La Subtarea fue editada"
                : "La Subtarea fue creada";
              thiss.$message.success(message);
              thiss.GetGanttObjectives();
              isSubmit = true;
            } catch (err) {
              console.error(err);
              thiss.GetGanttObjectives();
              isSubmit = true;
            }
            return true;
          }

          if (!isSubmit) {
            try {
              await thiss.$http.post("/api/cmi/task/AddTaskGantt", body);
              let message = body.ID
                ? "La tarea fue editada"
                : "La tarea fue creada";
              thiss.$message.success(message);
              thiss.GetGanttObjectives();
              isSubmit = true;
            } catch (err) {
              console.error(err);
              thiss.GetGanttObjectives();
              isSubmit = true;
            }
          }
          return true;
        }
        return;
      } else {
        gantt.alert({
          text: "Usted no es responsable ni creador de esta Tarea.",
          title: "Error!",
          ok: "OK",
          type: "error",
          callback: function (result) {
            if (result) thiss.GetGanttObjectives();
          }
        });
      }
      return false;
    }
  } else if (taskOlds[0].$new && !isSubmit) {
    thiss.OpenObjeID = taskOlds[0].id;
    body = {
      ID: null,
      CombinedId: null,
      CompanySeleted: thiss.currentCompany,
      DateInit: task.start_date,
      DateEnd: task.end_date,
      Description: task.text,
      Details: task.details,
      Name: task.text,
      TypeObjetive: "",
      ResposibleID: task.owner_id,
      Owner: thiss.currentUser.EmployeeId,
      PerpectiveId: thiss.PerpectiveId,
      TypeStrategic:
        thiss.currentUser.PositionID == 16 ? task.type_strategic : 1
    };

    thiss.loading = true;
    try {
      await thiss.$http.post("/api/CMI/Objetives/addNewObjetiveGantt", body);
      thiss.$message.success("El objetivo fue creado");
      thiss.GetGanttObjectives();
      isSubmit = true;
      // Este evento hace que la data de la tabla se refresque
      thiss.$emit("submit-success");
      thiss.$emit("update-data");
    } catch (err) {
      thiss.GetGanttObjectives();
      isSubmit = true;
      thiss.$message({
        type: "error",
        message: err.message
      });
    }
    return;
  } else if (!taskOlds[0].$new && !isSubmit) {
    if (thiss.currentUser.EmployeeId != task.created_by) {
      gantt.alert({
        text: `Usted no es el creador o responsable de ${
          taskOlds.parent ? " esta tarea " : " este objetivo "
        } para poder Editarlo.`,
        title: "Error!",
        ok: "OK",
        type: "error",
        callback: function (result) {
          if (result) thiss.GetGanttObjectives();
        }
      });
      return false;
    }
    thiss.OpenObjeID = taskOlds[0].id;
    body = {
      ID: task.id,
      CombinedId: task.id,
      CompanySeleted: thiss.currentCompany,
      DateInit: task.start_date,
      DateEnd: task.end_date,
      Description: task.text,
      Details: task.details,
      Name: task.text,
      TypeObjetive: "",
      ResposibleID: task.owner_id,
      Owner: thiss.currentUser.EmployeeId,
      PerpectiveId: task.type,
      TypeStrategic:
        thiss.currentUser.PositionID == 16 ? task.type_strategic : 1
    };
    thiss.loading = true;
    try {
      await thiss.$http.post("/api/CMI/Objetives/addNewObjetiveGantt", body);

      // Este evento hace que la data de la tabla se refresque
      thiss.$emit("submit-success");
      thiss.$message.success("El objetivo fue actualizado");
      thiss.GetGanttObjectives();
      isSubmit = true;
    } catch (err) {
      thiss.GetGanttObjectives();
      isSubmit = true;
      thiss.$message({
        type: "error",
        message: err.message
      });
    }
    return;
  }
  isSubmit = false;
};

const controlsOfDate = (
  parentDateInit,
  parentDateEnd,
  taskDateInit,
  tasktDateEnd,
  gantt
) => {
  if (taskDateInit < parentDateInit) {
    gantt.alert({
      text: "La fecha inicial no puede iniciar antes que el del Objectivo",
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  }
  if (taskDateInit > parentDateEnd) {
    gantt.alert({
      text: "La fecha inicial no puede iniciar después de la fecha fin del Objectivo",
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  }
  if (tasktDateEnd > parentDateEnd) {
    gantt.alert({
      text: "La fecha fin no puede finalizar después que el del Objectivo",
      title: "Error!",
      ok: "OK",
      type: "error"
    });
    return false;
  }
  return true;
};

const KnowIfThereIsTimeToAsign = async (row, thiss) => {
  let isThereTimeToAsignPromise = await new Promise((resolve, reject) => {
    // this.loadingData = true;

    // await Promise.all(
    thiss.$http
      .get("/api/ReporteGestion/KnowIfThereAreTasksWithoutTimeAsigned", {
        params: {
          CompanySelected: "TB",
          GerenciaID: null,
          ResponsableID: row.owner_id,
          WeekOnMothSelected: null,
          Year: null,
          Month: null,
          closed: false
        }
      })
      .then((response) => {
        //this.loadingData = false;
        resolve(response.data);
      })
      .catch((err) => {
        // this.loadingData = false;
        thiss.$message.error("Error al cargar los datos de las tareas.");
        reject(err);
      })
      .finally(() => {
        // this.loadingData = false;
      });
  });
  return isThereTimeToAsignPromise;
};

export default SaveGantt;
